<template>
  <div>
    <b-modal
      id="delete-document-type-modal"
      hide-footer
      @hidden="$emit('hidden')"
    >
      <div class="d-flex flex-column align-items-center justify-content-center">
        <h4>
          Are you sure you want to delete {{ documentTypeName }} ?
        </h4>
      </div>
      <div class="mt-1 d-flex justify-content-around">
        <b-button
          variant="primary"
          :disabled="loadingDeleteBtn"
          @click="deleteDocumentType"
        >
          <b-spinner
            v-if="loadingDeleteBtn"
            small
          />
          <span v-else>Delete</span>

        </b-button>
        <b-button
          variant="outline-danger"
          @click="$bvModal.hide('delete-document-type-modal')"
        >
          Cancel
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>

import { BModal, BButton, BSpinner } from 'bootstrap-vue'
import { computed, ref } from '@vue/composition-api'

export default {
  components: {
    BModal, BButton, BSpinner,
  },
  props: {
    documentType: {
      type: Object,
      default: undefined,
    },
  },
  setup(props, ctx) {
    const loadingDeleteBtn = ref(false)
    const documentTypeName = computed(() => (props.documentType ? props.documentType.name.en : ''))
    const deleteDocumentType = async () => {
      try {
        loadingDeleteBtn.value = true
        await ctx.root.$store.dispatch('business/deleteDocumentType', props.documentType.id)
        ctx.root.$bvModal.hide('delete-document-type-modal')
        ctx.emit('deleted')
      } catch (error) {
        console.log(error)
      } finally {
        loadingDeleteBtn.value = false
      }
    }

    return {
      deleteDocumentType,
      documentTypeName,
      loadingDeleteBtn,
    }
  },

}

</script>
